// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-k_gS","advertDetailHeaderPrice__value":"c-k_gT","advertDetailHeaderPrice__label":"c-k_gU"};